/**
 * @file コンポーネント：フル動画ページ症例タグリスト ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const Taglist = (props) => {
    // Presenterに渡す
    return <Presenter {...props} />;
};
